import { Slide, toast } from "react-toastify";

import type { ResponseError } from "./types";

export const Toast = {
  showSuccess: (success: string, autoCloseDuration = 3_000) => {
    toast(success, {
      type: "success",
      theme: "light",
      position: "top-center",
      transition: Slide,
      autoClose: autoCloseDuration,
      toastId: success,
      closeButton: true,
    });
  },
  showWarning: (warning: string, autoCloseDuration = 3_000) => {
    toast(warning, {
      type: "warning",
      theme: "light",
      position: "top-center",
      transition: Slide,
      autoClose: autoCloseDuration,
      toastId: warning,
      closeButton: true,
    });
  },
  showInfo: (info: string, autoCloseDuration = 3_000) => {
    toast(info, {
      type: "info",
      theme: "light",
      position: "top-center",
      transition: Slide,
      autoClose: autoCloseDuration,
      toastId: info,
      closeButton: true,
    });
  },
  showError: (error: unknown | string, autoCloseDuration = 3_000) => {
    toast.clearWaitingQueue();

    let msg;
    if (typeof error === "string") {
      msg = error;
    } else {
      msg =
        (error as unknown as ResponseError)?.message || "Something went wrong";
    }

    toast(msg, {
      type: "error",
      theme: "colored",
      position: "top-center",
      transition: Slide,
      autoClose: autoCloseDuration,
      toastId: msg,
    });
  },
};

export default Toast;
